<template>
    <div>
        <ul class="vx-timeline">
            <li v-for="item in base.approvalDatas" :key="item.id">
                <div class="timeline-icon" :class="(item.status === 1 ? true : false) ? 'bg-primary' : (item.status === 0 ? 'bg-grey' : 'bg-danger')">
                    <feather-icon :icon="(item.status === 1 ? true : false) ? 'CheckIcon' : 'XIcon'" svgClasses="text-white stroke-current w-5 h-5" />
                </div>
                <div
                    class="timeline-info px-3 py-4 shadow-drop rounded-lg"
                    :class="[item.should_be_approved && 'flex items-center justify-between', !item.should_be_approved & !(item.status === 1 ? true : false) && 'bg-grey-light cursor-not-allowed']"

                >
                    <div class="">
                        <!-- <h5 class="mb-2">{{ item.title }}</h5> -->
                        <div class="activity-desc">
                            <div class="mb-1">
                                <feather-icon icon="UserIcon" svg-classes="w-5 h-5" /> {{ item.name }}
                            </div>
                            <div class="">
                                <p>{{ item.comment }}</p>
                            </div>
                        </div>
                        <div class="font-semibold text-primary text-right text-sm" v-if="item.date_action">
                            {{ item.status === 1 ? 'Approuvé' : '' }} {{ item.status === 2 ? 'Rejeté' : '' }} le {{ item.date_action }}
                        </div>
                    </div>
                    <div class="" v-if="item.should_be_approved && item.id === $store.state.AppActiveUser.id">
                        <vs-button type="border" size="small" class="mr-4" @click.stop="request_approuval(item.id)">APPROUVER</vs-button>
                        <vs-button style="color: red; border: 1px solid rgb(251, 3, 3) !important;" type="border" size="small" @click.stop="rejectRequest(item)">REJETER</vs-button>

                    </div>
                </div>
            </li>
        </ul>

        <vs-popup
            title="Commentaire"
            accept-text= "Valider"
            button-cancel = "border"
            :buttons-hidden="true"
            @accept="request_rejet()"
            cancel-text="Annuler"
            :active.sync="activePrompt">
                <form>
                    <div class="vx-row">
                        <div class="vx-col w-full">
                            <vs-textarea
                                @keyup="changeverifier('comment')"
                                :class="input_error.comment ? 'ccmt' : ''"
                                label="Description *" v-model="input.comment"/>
                                <p class="span-text-validation" v-if="input_error.comment" :style="(!input_error.comment) ? '' : 'color:red; margin-top: -18px; margin-bottom: 20px'"> Le Commentaire est réquis. </p>
                        </div>
                    </div>
                </form>

                <div style="margin-bottom: 10px !important;">
                    <vs-button class="mr-6" @click="request_rejet()" :disabled="!isFormValid"> Valider </vs-button>
                    <vs-button type="border" color="danger" @click="activePrompt = false, initValues()">Annuler</vs-button>
                </div>
        </vs-popup>
    </div>
</template>

<script>
    let base_self;
    let input_tempon = {
        user_id: '',
        comment: '',
    };
    let input_error_tempon = {
        user_id: false,
        comment: false,
    };

    export default {
        props: {
            data: {
                type: Array,
                required: true,
            },
            base: {
                required: true
            }
        },
        data() {
            return {
                activePrompt: false,
                input_error: JSON.parse(JSON.stringify(input_error_tempon)),
                input: JSON.parse(JSON.stringify(input_tempon)),
            }
        },
        computed: {
            isFormValid () {
                var is_ok = true;

                if (!base_self.input.comment.length ) is_ok = false;

                return is_ok;
            }
        },
        methods: {
            changeverifier (libelle) {
                if (!base_self.input[libelle].length) {
                    base_self.input_error[libelle] = true;
                } else {
                    base_self.input_error[libelle] = false;
                }
            },
            rejectRequest(item){
              base_self.input.user_id = item.id
              base_self.activePrompt = true
            },
            initValues () {
                base_self.activePrompt = false;
                base_self.input = JSON.parse(JSON.stringify(input_tempon));
                base_self.input_error = JSON.parse(JSON.stringify(input_error_tempon));
            },
            async request_approuval(id) {
                base_self.$vs.loading()
                let response = await base_self.$store.state.requests_approve({ user_id: id, id: window.SingleRequestApp.$route.params.id });
                if (response.data.status) {
                    base_self.$vs.loading.close()
                    window.GETCCMT.success('La demande est approuvée avec succès.', response);
                } else {
                    base_self.$vs.loading.close()
                    window.GETCCMT.error({ message: 'L\'approbation de la demande a échouée.' });
                }
                window.SingleRequestApp.general();
            },
            async request_rejet() {
                base_self.$vs.loading()
                base_self.input.id = window.SingleRequestApp.$route.params.id;
                let response = await base_self.$store.state.requests_reject(base_self.input);
                if (response.data.status) {
                    base_self.$vs.loading.close()
                    window.GETCCMT.success('La demande est rejetée avec succès.', response);
                } else {
                    base_self.$vs.loading.close()
                    window.GETCCMT.error({ message: 'Le rejet de la demande a échouée.' });
                }
                window.SingleRequestApp.general();
                base_self.initValues();
            }
        },
        created() {
            base_self = this;
        }

    }
</script>

<style lang="scss">
    @import "@/assets/scss/vuesax/components/vxTimeline.scss";
</style>
